import { render, staticRenderFns } from "./InputCheckBox.vue?vue&type=template&id=961c7e92&scoped=true"
import script from "./InputCheckBox.vue?vue&type=script&lang=js"
export * from "./InputCheckBox.vue?vue&type=script&lang=js"
import style0 from "./InputCheckBox.vue?vue&type=style&index=0&id=961c7e92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961c7e92",
  null
  
)

export default component.exports